module.exports = __webpack_public_path__ + "07883e93734b98cae0f7b9c55d287250.svg";